export default "__VITE_ASSET__0y$HPs$d__"